import actionTypes from '../constants/action-types';

const progress = (state = { progress: 0 }, action) => {
  if (action.type !== actionTypes.SET_PROGRESS) return state;
  return action.payload.progress;
};

export default progress;
